import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {Box, Button} from '@mui/material';

interface NavBarDesktopMenuProps {
  navItems: AvatarMenuItem[];
}

export default function NavBarDesktopMenu({navItems}: NavBarDesktopMenuProps) {
  return (
    <Box data-testid="navbar-desktop-menu" sx={{display: {xs: 'none', md: 'flex'}, gap: 3, flexGrow: 1}}>
      {navItems.map((item, index) => (
        <Button
          key={typeof item.label === 'string' ? item.label : item.label?.toString()}
          onClick={item.onClick}
          data-testid={`navbar-desktop-menu-item-${typeof item.label === 'string' ? item.label.toLowerCase().replace(' ', '-') : index}`}
          sx={{
            color: 'text.primary',
            '&:hover': {
              backgroundColor: 'grey.100',
              color: 'primary.main',
            },
          }}
        >
          {item.label}
        </Button>
      ))}
    </Box>
  );
}
